<template>
  <div class="image-options-setting-dialog">
    <div v-show="activeType == 1" class="content-group-default">
      <el-collapse v-model="activeNames">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '2')" title="外观" name="2">
          <div class="content">
            <div class="content-item">
              <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
            </div>
            <div class="content-item mt16">
              <div v-show="borderChecked" class="select-input-container">
                <border-radius
                  :borderTypeFlag.sync="borderTypeFlag"
                  :borderRadius.sync="borderRadius"
                  :borderTopLeftRadius.sync="borderTopLeftRadius"
                  :borderTopRightRadius.sync="borderTopRightRadius"
                  :borderBottomRightRadius.sync="borderBottomRightRadius"
                  :borderBottomLeftRadius.sync="borderBottomLeftRadius"
                />
              </div>
            </div>
            <div class="content-item mt16 clearFloat">
              <div class="checkbox_colorPicker_container mb16">
                <span class="fs14">边框</span>
              </div>
              <div v-show="borderChecked" class="select-input-container verticallyTop">
                <cx-border
                  :borderWidth.sync="borderWidth"
                  :borderStyle.sync="borderStyle"
                  :borderColor.sync="borderColor"
                  :borderIsThemeColor.sync="borderIsThemeColor"
                />
              </div>
            </div>
            <div class="content-item mt16">
              <cx-padding
                :paddingTypeFlag.sync="paddingTypeFlag"
                :padding.sync="padding"
                :paddingTop.sync="paddingTop"
                :paddingRight.sync="paddingRight"
                :paddingBottom.sync="paddingBottom"
                :paddingLeft.sync="paddingLeft"
              />
            </div>
            <cx-background :background.sync="background" imgType="10" class="mt16" />
            <div class="content-item mt16">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              ></box-shadow>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '3')" title="切换项" name="3">
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')"
          >
            <div class="content-item clearFloat">
              <div class="title14_20 mb8">文字</div>
              <text-setting-complex-update
                class="mb8"
                :fontFamily.sync="fontFamily"
                :fontSize.sync="fontSize"
                :fontWeight.sync="fontWeight"
                :fontStyle.sync="fontStyle"
                :textDecoration.sync="textDecoration"
                :lineHeight.sync="lineHeight"
                :letterSpacing.sync="letterSpacing"
                :activeArrangement.sync="activeArrangement"
                :writingMode.sync="writingMode"
                :textAlign.sync="textAlign"
                :activeArrangementOrder.sync="activeArrangementOrder"
                :lineHeightType.sync="lineHeightType"
                :letterSpacingType.sync="letterSpacingType"
                :showColorSet="false"
                :options="options"
              />
            </div>
            <div class="verticallyCenter">
              <span class="fs14 mr16">颜色</span>
              <color-picker-theme-color class="flex1" :isThemeColor.sync="textIsThemeColor" :color.sync="color">
              </color-picker-theme-color>
            </div>
            <div class="content-item mt16">
              <cx-padding
                :paddingTypeFlag.sync="itemPaddingTypeFlag"
                :padding.sync="itemPadding"
                :paddingTop.sync="itemPaddingTop"
                :paddingRight.sync="itemPaddingRight"
                :paddingBottom.sync="itemPaddingBottom"
                :paddingLeft.sync="itemPaddingLeft"
              />
            </div>
            <div class="content-item clearFloat mt16">
              <div class="title14_20">切换项间距</div>
              <div class="slider-input-container">
                <el-slider
                  class="mr16"
                  style="width: 256px; height: 4px"
                  :show-tooltip="false"
                  v-model="marginRight"
                ></el-slider>
                <single-input
                  style="width: 80px; height: 28px"
                  :value.sync="marginRight"
                  inputSuffixs="px"
                />
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '4')" title="图标样式" name="4">
          <div class="content-item">
            <el-checkbox v-model="isShowIcon" class="mb16">显示图标</el-checkbox>
            <img-icon-upload class="mb16" :imgSrc.sync="iconSrc1" :iconType.sync="iconType1" :iconColor="iconColor" />
            <div class="content-item mb16 verticallyCenter">
              <span class="mr16 fs14">位置</span>
              <el-radio-group v-model="iconPosition">
                <el-radio label="left">左</el-radio>
                <el-radio label="right">右</el-radio>
              </el-radio-group>
            </div>
            <div class="verticallyCenter mb16" v-if="iconType1 === 'icon'">
              <span class="mr16 fs14">颜色</span>
              <color-picker-theme-color
                class="flex1"
                :isThemeColor.sync="iconColorIsThemeColor"
                :color.sync="iconColor"
              >
              </color-picker-theme-color>
            </div>

            <slider-and-input class="mb16" :value.sync="iconWidth" title="大小" :sliderMax="sliderMax" suffix="px" />
            <slider-and-input :value.sync="iconMargin" title="间距" :sliderMax="sliderMax" suffix="px" />
          </div>
        </el-collapse-item>
        <el-collapse-item title="分隔符" name="5">
          <el-checkbox v-model="showDivide">显示分隔符</el-checkbox>
          <div class="content-item mt12" v-if="showDivide">
            <cx-slider label="类型" :value.sync="divideType" :options="divideTypeOptions" />
            <div class="mt12" v-if="divideType === 'custom'">
              <img-icon-upload
                :imgSrc.sync="divideIconSrc"
                :iconType.sync="divideIconType"
                :iconColor.sync="divideIconColor"
                :resInfo.sync="divideResInfo"
              />
              <div class="verticallyCenter mt12" v-if="divideIconType !== 'img'">
                <span class="mr16 fs14">颜色</span>
                <cx-color-picker class="flex1" :isThemeColor.sync="divideIconColorIsThemeColor" :colorArr.sync="divideIconColor">
                </cx-color-picker>
              </div>
            </div>
            <div class="mt12" v-else>
              <div class="verticallyCenter">
                <span class="mr16 fs14">颜色</span>
                <cx-color-picker class="flex1" :isThemeColor.sync="iconColorIsThemeColor" :colorArr.sync="divideIconColor">
                </cx-color-picker>
              </div>
            </div>
            <div class="verticallyCenter mt12">
              <span class="mr16 fs14">尺寸</span>
              <div class="verticallyCenter mr16 flex1">
                <single-input
                  class="input-size"
                  placeholder="-"
                  :value.sync="divideWidth"
                  :min="1"
                  inputSuffixs="宽"
                 />
                </div>
              <div class="verticallyCenter flex1">
                <single-input
                  class="input-size"
                  placeholder="-"
                  :value.sync="divideHeight"
                  :min="1"
                  inputSuffixs="高"
                />
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div v-show="activeType == 2" class="content-group-hover">
      <el-collapse v-model="hoverActiveNames">
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="切换项" name="1">
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')"
          >
            <div class="content">
              <text-setting-complex-update
                class="mb8"
                :fontFamily.sync="hoverFontFamily"
                :fontSize.sync="hoverFontSize"
                :fontWeight.sync="hoverFontWeight"
                :fontStyle.sync="hoverFontStyle"
                :textDecoration.sync="hoverTextDecoration"
                :lineHeight.sync="hoverLineHeight"
                :letterSpacing.sync="hoverLetterSpacing"
                :activeArrangement.sync="hoverActiveArrangement"
                :writingMode.sync="hoverWritingMode"
                :textAlign.sync="hoverTextAlign"
                :showTextAlignSetting="false"
                :activeArrangementOrder.sync="hoverActiveArrangementOrder"
                :lineHeightType.sync="hoverLineHeightType"
                :letterSpacingType.sync="hoverLetterSpacingType"
                :showColorSet="false"
                :options="options"
              />
              <div class="verticallyCenter mb16">
                <span class="fs14 mr16">颜色</span>
                <color-picker-theme-color
                  class="flex1"
                  :isThemeColor.sync="hoverTextIsThemeColor"
                  :color.sync="hoverColor"
                >
                </color-picker-theme-color>
              </div>
              <div class="mb16">
                <p class="mb8 fs14">图标样式</p>
                <img-icon-upload :imgSrc.sync="iconSrc2" :iconType.sync="iconType2" :iconColor="iconColor" />
              </div>
              <div class="verticallyCenter mb16" v-if="iconType2 === 'icon'">
                <span class="mr16 fs14">颜色</span>
                <color-picker-theme-color
                  class="flex1"
                  :isThemeColor.sync="iconColorIsThemeColor2"
                  :color.sync="iconColor2"
                >
                </color-picker-theme-color>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import TextSettingComplex from "modules/components/textSettingComplex"
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  name: "image-options-data",
  components: { controlWidthAndSizeAndZindex, TextSettingComplex },
  props: { options: Object, activeType: String },
  data() {
    return {
      this1: this,
      collapseActiveNames: ["1", "2", "3", "4", "5"],
      activeNames: ["1", "2", "3", "4", "5"],
      hoverActiveNames: ["1"],
      iconLocations: [
        {
          value: "left",
          title: "文字居左"
        },
        {
          value: "right",
          title: "文字居右"
        }
      ],
      isShowBackgroundList: [
        {
          label: 0,
          title: "无背景"
        },
        {
          label: 1,
          title: "有背景"
        }
      ],
      borderChecked: true,
      sliderMax: 360,
      divideTypeOptions: [
        {
          value: "line",
          title: "竖线",
        },
        {
          value: "custom",
          title: "自定义",
        },
      ],
    }
  },
  comments: {},
  created() {},
  mounted() {},
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    activeRect() {
      // this.options();
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    activeArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "writingMode", false)
      }
    },
    hoverActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.hoverWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "hoverWritingMode", false)
      }
    },
    activeArrangement() {
      return this.options.textAlign
    },
    hoverActiveArrangement() {
      return this.options.hoverTextAlign
    },
    width: {
      get() {
        return this.options.width
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "width", false)
      }
    },
    height: {
      get() {
        return this.options.height
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "height", false)
      }
    },
    iconWidth: {
      get() {
        return this.options.iconWidth || 16
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "iconWidth", false)
      }
    },
    iconHeight: {
      get() {
        return this.options.iconHeight || 16
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "iconHeight", false)
      }
    },
    left: {
      get() {
        return this.options.left
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "left", false)
      }
    },
    top: {
      get() {
        return this.options.top
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "top", false)
      }
    },
    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontFamily", false)
      }
    },
    hoverFontFamily: {
      get() {
        return this.options.hoverFontFamily || this.options.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.options.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontSize", false)
      }
    },
    hoverFontSize: {
      get() {
        return this.options.hoverFontSize || parseInt(this.options.fontSize)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontWeight", false)
      }
    },
    hoverFontWeight: {
      get() {
        return this.options.hoverFontWeight || this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontWeight", false)
      }
    },
    color: {
      get() {
        return this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    textIsThemeColor: {
      get() {
        return this.options.textIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIsThemeColor", false)
      }
    },
    hoverColor: {
      get() {
        return this.options.hoverColor || this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverColor", false)
      }
    },
    hoverTextIsThemeColor: {
      get() {
        return this.options.hoverTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextIsThemeColor", false)
      }
    },
    textAlign: {
      get() {
        return this.options.textAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textAlign", false)
      }
    },
    hoverTextAlign: {
      get() {
        return this.options.hoverTextAlign || this.options.textAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextAlign", false)
      }
    },
    fontStyle: {
      get() {
        return this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontStyle", false)
      }
    },
    hoverFontStyle: {
      get() {
        return this.options.hoverFontStyle || this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontStyle", false)
      }
    },
    lineHeight: {
      get() {
        return this.options.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeight", false)
      }
    },
    hoverLineHeight: {
      get() {
        return this.options.hasOwnProperty("hoverLineHeight") ? this.options.hoverLineHeight : this.options.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLineHeight", false)
      }
    },
    letterSpacing: {
      get() {
        return this.options.letterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "letterSpacing", false)
      }
    },
    hoverLetterSpacing: {
      get() {
        return this.options.hasOwnProperty("hoverLetterSpacing")
          ? this.options.hoverLetterSpacing
          : this.options.letterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "hoverLetterSpacing", false)
      }
    },
    writingMode: {
      get() {
        return this.options.writingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "writingMode", false)
      }
    },
    hoverWritingMode: {
      get() {
        return this.options.hasOwnProperty("hoverWritingMode")
          ? this.options.hoverWritingMode
          : this.options.writingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverWritingMode", false)
      }
    },
    textDecoration: {
      get() {
        return this.options.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textDecoration", false)
      }
    },
    hoverTextDecoration: {
      get() {
        return this.options.hoverTextDecoration || this.options.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextDecoration", false)
      }
    },
    textIndent: {
      get() {
        return this.options.textIndent
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIndent", false)
      }
    },
    hoverTextIndent: {
      get() {
        return this.options.hoverTextIndent || this.options.textIndent
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextIndent", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColor", false)
      }
    },
    hoverBgColor: {
      get() {
        return this.options.hoverBgColor || this.options.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBgColor", false)
      }
    },
    marginRight: {
      get() {
        return this.options.marginRight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "marginRight", false)
      }
    },
    borderTopLeftRadius: {
      get() {
        return Number(this.options.borderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return Number(this.options.borderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return Number(this.options.borderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderWidth", "borderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.options.borderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    hoverBorderIsThemeColor: {
      get() {
        return this.options.hoverBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderIsThemeColor", false)
      }
    },
    bgColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColorIsThemeColor", false)
      }
    },
    hoverBgColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("hoverBgColorIsThemeColor") ? this.options.hoverBgColorIsThemeColor : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBgColorIsThemeColor", false)
      }
    },
    hoverBorderWidth: {
      get() {
        return this.options.hasOwnProperty("hoverBorderWidth")
          ? this.options.hoverBorderWidth
          : this.options.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderWidth", false)
      }
    },
    hoverBorderStyle: {
      get() {
        return this.options.hasOwnProperty("hoverBorderStyle")
          ? this.options.hoverBorderStyle
          : this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderStyle", false)
      }
    },
    opacity: {
      get() {
        return this.options.hasOwnProperty("opacity") ? this.options.opacity : 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    // 背景色
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = []
        if (this.bgType === "线性渐变") {
          newBackground.push({
            type: "linearGradient",
            label: "线性渐变",
            data: {
              angle: this.bgColorlinearGradientAngle,
              stops: [
                [this.bgStartColor, 0],
                [this.bgEndColor, 1]
              ]
            }
          })
        }
        if (this.bgType === "径向渐变") {
          newBackground.push({
            type: "radialGradient",
            label: "径向渐变",
            data: {
              siteX: 50,
              siteY: 50,
              stops: [
                [this.bgStartColor, 0],
                [this.bgEndColor, 1]
              ]
            }
          })
        }
        newBackground.push({
          type: "color",
          label: "颜色",
          isThemeColor: false,
          color: this.bgType === "纯色" ? this.bgColor : "rgba(0,0,0,0)"
        })
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    bgType: {
      get() {
        return this.options.bgType || "纯色"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgType", false)
      }
    },
    bgStartColor: {
      get() {
        return this.options.bgStartColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgStartColor", false)
      }
    },
    bgEndColor: {
      get() {
        return this.options.bgEndColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgEndColor", false)
      }
    },
    // 阴影
    boxShadowColor: {
      get() {
        return this.options.hasOwnProperty("boxShadowColor") ? this.options.boxShadowColor : ["rgba(255,255,255,1)"]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.hasOwnProperty("boxShadowH") ? this.options.boxShadowH : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.hasOwnProperty("boxShadowV") ? this.options.boxShadowV : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.hasOwnProperty("boxShadowBlur") ? this.options.boxShadowBlur : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.hasOwnProperty("boxShadowSpread") ? this.options.boxShadowSpread : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    // 边距
    paddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("paddingTypeFlag")) {
          if (((this.paddingTop === this.paddingRight) === this.paddingLeft) === this.paddingBottom) {
            defaultType = 2
          }
        }
        // return this.checkAndSetPrimaryVal(this.options, "paddingTypeFlag", "paddingTypeFlag", defaultType)
        return this.options.paddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        // return this.options.padding || 0
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        // return this.options.paddingRight || 0
        return this.checkAndSetPrimaryVal(this.options, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        // return this.options.paddingLeft || 0
        return this.checkAndSetPrimaryVal(this.options, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        // return this.options.paddingBottom || 0
        return this.checkAndSetPrimaryVal(this.options, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    // 切换项边距
    itemPaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("itemPaddingTypeFlag")) {
          if (((this.itemPaddingTop === this.itemPaddingRight) === this.itemPaddingLeft) === this.itemPaddingBottom) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "itemPaddingTypeFlag", "itemPaddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "itemPaddingTypeFlag", false)
      }
    },
    itemPadding: {
      get() {
        // return this.options.padding || 0
        return this.checkAndSetPrimaryVal(this.options, "itemPadding", "itemPadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "itemPadding", false)
      }
    },
    itemPaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "itemPaddingTop", "itemPaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "itemPaddingTop", false)
      }
    },
    itemPaddingRight: {
      get() {
        // return this.options.paddingRight || 0
        return this.checkAndSetPrimaryVal(this.options, "itemPaddingRight", "itemPaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "itemPaddingRight", false)
      }
    },
    itemPaddingLeft: {
      get() {
        // return this.options.paddingLeft || 0
        return this.checkAndSetPrimaryVal(this.options, "itemPaddingLeft", "itemPaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "itemPaddingLeft", false)
      }
    },
    itemPaddingBottom: {
      get() {
        // return this.options.paddingBottom || 0
        return this.checkAndSetPrimaryVal(this.options, "itemPaddingBottom", "itemPaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "itemPaddingBottom", false)
      }
    },
    // 图标
    iconPosition: {
      get() {
        return this.options.iconPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconPosition", false)
      }
    },
    iconSrc1: {
      get() {
        return this.options.iconSrc1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconSrc1", false)
      }
    },
    iconType1: {
      get() {
        return this.options.iconType1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconType1", false)
      }
    },
    iconMargin: {
      get() {
        return this.options.iconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconMargin", false)
      }
    },
    iconColor: {
      get() {
        return this.options.iconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColor", false)
      }
    },
    iconColorIsThemeColor: {
      get() {
        return this.options.iconColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColorIsThemeColor", false)
      }
    },
    isShowIcon: {
      get() {
        return this.options.hasOwnProperty("isShowIcon") ? this.options.isShowIcon : true
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isShowIcon", false)
      }
    },
    iconSrc2: {
      get() {
        return this.options.iconSrc2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconSrc2", false)
      }
    },
    iconType2: {
      get() {
        return this.options.iconType2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconType2", false)
      }
    },
    iconColor2: {
      get() {
        return this.options.hasOwnProperty("iconColor2") ? this.options.iconColor2 : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColor2", false)
      }
    },
    iconColorIsThemeColor2: {
      get() {
        return this.options.hasOwnProperty("iconColorIsThemeColor2") ? this.options.iconColorIsThemeColor2 : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColorIsThemeColor2", false)
      }
    },
    lineHeightType: {
      get() {
        return this.options.lineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeightType", false)
      }
    },
    letterSpacingType: {
      get() {
        return this.options.letterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacingType", false)
      }
    },
    hoverLineHeightType: {
      get() {
        return this.options.hoverLineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLineHeightType", false)
      }
    },
    hoverLetterSpacingType: {
      get() {
        return this.options.hoverLetterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLetterSpacingType", false)
      }
    },
    showDivide: {
      get() {
        return this.options.hasOwnProperty("showDivide") ? this.options.showDivide : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showDivide", false)
      }
    },
    divideType: {
      get() {
        return this.options.hasOwnProperty("divideType") ? this.options.divideType : "line"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideType", false)
      }
    },
    divideWidth: {
      get() {
        return this.options.hasOwnProperty("divideWidth") ? this.options.divideWidth : 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideWidth", false)
      }
    },
    divideHeight: {
      get() {
        return this.options.hasOwnProperty("divideHeight") ? this.options.divideHeight : 24
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideHeight", false)
      }
    },
    divideIconSrc: {
      get() {
        return this.options.hasOwnProperty("divideIconSrc") ? this.options.divideIconSrc : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideIconSrc", false)
      }
    },
    divideIconType: {
      get() {
        return this.options.hasOwnProperty("divideIconType") ? this.options.divideIconType : "icon"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideIconType", false)
      }
    },
    divideIconColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("divideIconColorIsThemeColor") ? this.options.divideIconColorIsThemeColor : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideIconColorIsThemeColor", false)
      }
    },
    divideIconColor: {
      get() {
        return this.options.hasOwnProperty("divideIconColor") ? this.options.divideIconColor : "rgba(0,0,0,0.2)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideIconColor", false)
      }
    },
    divideResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "divideResInfo", "divideResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideResInfo", false)
      }
    }
  },
  methods: {
    switchHandle(type) {
      this.activeType = type
    },
    resetBorder(val) {
      this.borderRadius = val
      this.borderTopLeftRadius = val
      this.borderTopRightRadius = val
      this.borderBottomRightRadius = val
      this.borderBottomLeftRadius = val
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    checkboxHandle(flag, hoverFlag) {
      switch (flag) {
        case 1:
          // this.shapeType = "square"
          this[hoverFlag + "borderTopLeftRadius"] = 0
          this[hoverFlag + "borderTopRightRadius"] = 0
          this[hoverFlag + "borderBottomLeftRadius"] = 0
          this[hoverFlag + "borderBottomRightRadius"] = 0
          break
        case 2:
          this[hoverFlag + "borderColor"] = "#FFFFFF"
          this[hoverFlag + "borderWidth"] = 1
          this[hoverFlag + "borderStyle"] = "solid"
          this.changeBorderSelection(hoverFlag)
          break
        case 3:
          this[hoverFlag + "boxShadowColor"] = "#FFFFFF"
          this[hoverFlag + "boxShadowH"] = 0
          this[hoverFlag + "boxShadowV"] = 0
          this[hoverFlag + "boxShadowBlur"] = 0
          this[hoverFlag + "boxShadowSpread"] = 0
          break
        case 4:
          this[hoverFlag + "rotate"] = "0deg"
          break
      }
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH) || !Array.isArray(this.boxShadowColor)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    }
  }
})
</script>

<style lang="scss" scoped>
.w88 {
  width: 88px;
}
.w72 {
  width: 72px;
}
.content-item {
  .font-style input {
    width: 100%;
    height: 28px;
  }
}
</style>
